export default {
  setUser: (state, value) => (state.user = value),
  setUsers: (state, value) => (state.users = value)
}
